"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Abstract domain object, from which all domain objects should extend.
 *
 * @author Smi
 * @author JMe
 */

var DomainObject =
/*#__PURE__*/
function () {
  function DomainObject() {
    _classCallCheck(this, DomainObject);
  }

  _createClass(DomainObject, [{
    key: "toString",

    /**
     * Returns stringified representation of the object.
     *
     * @returns stringified object.
     */
    value: function toString() {
      return JSON.stringify(this);
    }
    /**
     * Clones object and alters given field by given value.
     *
     * @param field field that should be altered.
     * @param value field value.
     */

  }, {
    key: "copy",
    value: function copy(field, value) {
      var target = {};
      Object.assign(target, this);
      target[field] = value;
      Object.setPrototypeOf(target, Object.getPrototypeOf(this));
      return this.fixCopy(target);
    }
    /**
     * Clones object and alters it based on given partial object.
     * @param data partial T object with fields and values which should be altered
     */

  }, {
    key: "copyMulti",
    value: function copyMulti(data) {
      var target = {};
      Object.assign(target, this);
      Object.keys(data).forEach(function (key) {
        return target[key] = data[key];
      });
      Object.setPrototypeOf(target, Object.getPrototypeOf(this));
      return this.fixCopy(target);
    }
    /**
     * Post process step after copy. Default implementation returns given object.
     *
     * @param copy the copied object of result type T
     * @returns post processed object.
     */

  }, {
    key: "fixCopy",
    value: function fixCopy(copy) {
      return copy;
    }
    /**
     * Clones object and alters given field by given value IF the value is not null or undefined
     *
     * @param field field that should be altered.
     * @param value field value.
     */

  }, {
    key: "copyIfNotMissing",
    value: function copyIfNotMissing(field, value) {
      if (value !== undefined && value !== null) {
        return this.copy(field, value);
      }

      return this;
    }
  }]);

  return DomainObject;
}();

exports.DomainObject = DomainObject;